module.exports = __webpack_public_path__ + "img/water-hygiene.5b90454c.svg";